import { forwardRef } from "react";
import FieldWrapper from "./FieldWrapper";
import Input from "./Input";
import FieldErrorWrapper from "./FieldErrorWrapper";

export interface CheckboxFormFieldProps
  extends React.FormHTMLAttributes<HTMLFormElement> {
  submitting?: boolean;
  loading?: boolean;
  label?: string;
  children?: any;
  errorMessage?: string;
  errorWrapperClassName?: string;
  required?: boolean;
  value?: string;
}

const CheckboxFormField = (
  {
    label,
    errorMessage,
    children,
    className,
    name,
    errorWrapperClassName,
    id,
    ...field
  }: CheckboxFormFieldProps,
  ref,
) => {
  return (
    <FieldWrapper
      errorMessage={errorMessage}
      className={className || "unchained-checkbox-form-field"}
      type={"checkbox"}
      name={name}
    >
      <Input
        type={"checkbox"}
        id={id || name}
        name={name}
        {...(field as any)}
        ref={ref}
      />
      <label htmlFor={id || name}>{label}</label>
      {errorMessage && (
        <FieldErrorWrapper
          name={name}
          className={errorWrapperClassName}
          errorMessage={errorMessage}
        />
      )}
      {children || undefined}
    </FieldWrapper>
  );
};

export default forwardRef(CheckboxFormField);
